<input type="text"
       [placeholder]="placeholder"
       [(ngModel)]="value"
       [disabled]="disabled"
       (input)="onChange($event)"
       (blur)="onTouched()">
